import { AddMainActionButton, type AddMainActionButtonProps } from '../actions';

export type CreateButtonProps = AddMainActionButtonProps;

/**
 * @deprecated Use `import { AddMainActionButton } from '@/components/actions'` instead.
 */
export const CreateButton = AddMainActionButton;
